import type { VisualPromptCategory } from '@/types/visualPrompts/visualPrompt.types';

export interface PromptCategoryMeta {
  id: VisualPromptCategory | 'all';
  label: string;
}

export const PROMPT_CATEGORY_FILTERS: PromptCategoryMeta[] = [
  { id: 'all', label: 'All' },
  { id: 'writing', label: 'Writing' },
  { id: 'analysis', label: 'Analysis' },
  { id: 'meetings', label: 'Meetings' },
  { id: 'systems', label: 'Systems & tools' },
  { id: 'general', label: 'General' },
];

export const PROMPT_TYPE_LABELS: Record<string, string> = {
  instruction: 'Instruction',
  rewrite: 'Rewrite',
  explanation: 'Explanation',
  meetingNotes: 'Meeting notes',
  codeReview: 'Code review',
  extraction: 'Extraction',
  structured: 'Structured',
  creative: 'Creative',
  reasoning: 'Reasoning',
};
